// extracted by mini-css-extract-plugin
export var active = "pagination-module--active--EkOW0";
export var buttonFirst = "pagination-module--buttonFirst--HNFp2";
export var buttonLast = "pagination-module--buttonLast--kvT-p";
export var buttons = "pagination-module--buttons--AsiJR";
export var buttonsBlock = "pagination-module--buttonsBlock--a1Xi1";
export var buttonsBlockSmall = "pagination-module--buttonsBlockSmall--BQmEz";
export var invisible = "pagination-module--invisible--elJ5m";
export var leftToActive = "pagination-module--leftToActive--DtA6O";
export var rightToActive = "pagination-module--rightToActive--Ime5n";
export var root = "pagination-module--root--T0V8d";